"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductFragment = exports.productPreviewFragment = exports.productFragmentInclusive = exports.productFragment = void 0;
const image_1 = require("./image");
exports.productFragment = `
  fragment product on Product {
    id
    vatType {
      name
      percent
    }
    isVirtual
    isSubscriptionOnly
    defaultVariant {
      __typename
      id
      name
      sku
      price
      stock
      isDefault
      attributes {
        attribute
        value
      }
      images {
        ...image
      }
      subscriptionPlans {
        name
      }
    }
  }
`;
exports.productFragmentInclusive = `
  ${exports.productFragment}
  ${image_1.imageFragment}
`;
exports.productPreviewFragment = `
fragment productPreview on Product {
  id
  name
  defaultVariant {
    images {
      url
      variants {
        width
        url
        key
      }
      altText
    }
  }
}
`;
const getProductFragment = () => `
  ${exports.productFragment}
  ${image_1.imageFragment}
`;
exports.getProductFragment = getProductFragment;
//# sourceMappingURL=product.js.map